import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import translationEN from "../locales/en/translation.json";
import translationVI from "../locales/vi/translation.json";
import translationTH from "../locales/th/translation.json";
import translationES from "../locales/es/translation.json";
import { DEFAULT_LANGUAGE_CODE, LanguageCodeType } from "../constant/constant";

const resources: Record<LanguageCodeType, { translation: any }> = {
  en: {
    translation: translationEN,
  },
  vi: {
    translation: translationVI,
  },
  th: {
    translation: translationTH,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
